import { useEffect, useMemo, useState } from "react";
import "../stylestabs.scss";
import {
  DeleteOutlined, DownloadOutlined, DownOutlined, EditOutlined, MessageOutlined, SettingOutlined, UpOutlined, UserOutlined,
} from "@ant-design/icons";
import { Menu, Dropdown, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { ICustomerDetail_V4 } from "../../../../api/customer/customerApi";
import { phone_icon, email_icon, info_cicrle, avatar, avatarFemale, avatarMale, iconMarriage, iconOld, iconSex, none_rank } from "../../../../components/ExportImgFigma";
import { URL_CUSTOMER, URL_RANK } from "../../../../env";
import useDebounce from "../../../../hook/useDebounce";
import useLoading from "../../../../hook/useLoading";
import useToast from "../../../../hook/useToast";
import { CustomerType, dataGender, dataStatusMarital, FIELDTYPE, NO_DATA, NO_VIEW } from "../../../../services/data";
import { capitalizeEachWord, getTitleSelectOption } from "../../../../until";
import { FlattenedField } from "../../../CustomersV2/indexV2";
import ItemsInfomation from "../ItemsInfomation";
import * as customerApi_V2 from "../../../../api/Customer_V2/customerApi_V2";
import { ISelectOption } from "../../../../api/selectOptions/selectOptionsApi";
import EditInfomation from "./EditInfomation";
import { useSelector } from "react-redux";
import { selectorInfoUser } from "../../../../store/slices/infoUserSlice";
import CustomerFeilds from "../../../CustomersV2/Drawer/CustomerFeilds";
import ShowDetailBenefit from "../../Modal/ShowDetailBenefit";
import { getInfoCardCustomer, IInfoCardCustomer } from "../../../../api/rank/issuedCardApi";


interface Prop {
  isEdit?: boolean
  sLTypePhone: ISelectOption[]
  infoCustomer?: ICustomerDetail_V4;
  resultFormSubmitPersonalInfor: (iSsuccess: boolean, message?: string) => void
}

const InfomationLeft: React.FC<Prop> = ({
  isEdit, sLTypePhone, infoCustomer,
  resultFormSubmitPersonalInfor
}) => {
  const pushLoading = useLoading();
  const navigator = useNavigate();
  const pushToast = useToast();

  const { unitTemp } = useSelector(selectorInfoUser) // đợn vị dc chọn

  const [advanced, setAdvanced] = useState(false);
  const [isSettingShow, setSettingShow] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [isShowBenefit, setShowBenefit] = useState(false)



  const [dataFilterActive, setDataFilterActive] = useState<FlattenedField[]>([]);
  const [dataFilterNoActive, setDataFilterNoActive] = useState<customerApi_V2.ListField[]>([]);
  const [dataInfoCardCustomer, setDataInfoCardCustomer] = useState<IInfoCardCustomer>()


  const [infoCustomerByFields, setInfoCustomerByFields] = useState<customerApi_V2.ListFieldCustomer[]>([]);
  const [infoCustomerByFieldsActive, setInfoCustomerByFieldsAtive] = useState<customerApi_V2.ListFieldCustomer[]>([]);

  const menuProps = useMemo(() => {
    return {
      items: [
        {
          key: "edit",
          icon: <MessageOutlined className="icon-text-drop-menu" />,
          label: "Sửa khách hàng",
        },
        {
          key: "add",
          icon: <UserOutlined className="icon-text-drop-menu" />,
          label: "Thêm vào nhóm khách hàng",
        },
        {
          key: "export",
          icon: <DownloadOutlined className="icon-text-drop-menu" />,
          label: "Xuất dữ liệu",
        },
        {
          key: "delete",
          icon: <DeleteOutlined className="icon-text-drop-menu-red" />,
          label: <span className="text-red-500">Xóa khách hàng</span>,
        },
      ],
      onClick: (item: any) => {
        if (item.key === "edit") {
          setIsEditing(true);
        }
        // Thêm xử lý cho các menu item khác
      }
    };
  }, []);

  const fieldsToShow = useMemo(() => {
    if (isEditing) return infoCustomerByFieldsActive;
    return advanced
      ? infoCustomerByFieldsActive
      : infoCustomerByFieldsActive.slice(0, 11);
  }, [isEditing, advanced, infoCustomerByFieldsActive]);


  const mergeFields = (
    infoCustomerByFields: customerApi_V2.ListFieldCustomer[],
    dataFilterActive: FlattenedField[]
  ): customerApi_V2.ListFieldCustomer[] => {
    return dataFilterActive.map((field) => {
      const match = infoCustomerByFields.find(
        (item) => item.fieldCode === field.fieldCode
      );

      return {
        fieldId: field.id,
        fieldCode: field.fieldCode,
        fieldLabel: field.fieldLabel,
        value: match?.value ?? null,
        view: match?.view,
        edit: match?.edit
      };
    });
  };


  const gListFieldsActive = async () => {
    const result = await customerApi_V2.getListFieldsByCustomer(FIELDTYPE.CUSTOMER, 1, 1);
    if (result?.status) {
      const flattenedFields = result.data.flatMap((choice) =>
        choice.fields.map((field) => ({
          ...field,
          parentId: choice.id,
        }))
      );
      setDataFilterActive(flattenedFields);
      gListFieldsNotActive();
    }
  };

  const gListFieldsNotActive = async () => {
    const result = await customerApi_V2.getListFieldsByCustomer(FIELDTYPE.CUSTOMER, 0, 1);
    if (result?.status) {
      setDataFilterNoActive(result.data);
    }
  };

  const gInfoCustomerByFields = useDebounce(async () => {
    pushLoading(true)
    const result = await customerApi_V2.getInfoCustomerByFields(
      Number(infoCustomer?.id), unitTemp ?? undefined

    );
    if (result?.status) {
      setInfoCustomerByFields(result.data?.fields);
    } else {
      pushToast(result?.message, "warning");
      navigator(-1);
    }
    pushLoading(false)
  }, 1000);

  const onSaveDataFields = (
    iSsuccess?: boolean,
    message?: string,
    dataFilterActive?: FlattenedField[],
    dataFilterNoActive?: customerApi_V2.ListField[]
  ) => {
    if (iSsuccess) {
      setSettingShow(false);
      pushToast(message, "success");
      setDataFilterActive(dataFilterActive ?? []);
      setDataFilterNoActive(dataFilterNoActive ?? []);
      gInfoCustomerByFields();
    } else {
      pushToast(message, "warning");
    }
  };

  const resultFormSubmitPersonalInforLeft = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      gInfoCustomerByFields();
      setIsEditing(false)
      pushToast(message, "success")
      resultFormSubmitPersonalInfor?.(iSsuccess, message)
    }
    else {
      pushToast(message, "error")
    }
  }

  const toggleShowAll = () => {
    setAdvanced((prev) => !prev);
  };


  // lấy thông tin khahcs hàng để cho vào chỉnh sửa
  const gInfoCardCustomer = async (id?: number) => {

    if (!id) return
    const result = await getInfoCardCustomer(id);
    if (result.status) {
      setDataInfoCardCustomer(result.data);
    } else {
      pushToast(result.message, "error", 2000)

    }
  }

  useEffect(() => {
    if (isEdit)
      setIsEditing(true)
  }, [isEdit]);

  useEffect(() => {
    if (infoCustomerByFields.length)
      setInfoCustomerByFieldsAtive(
        mergeFields(infoCustomerByFields, dataFilterActive)
      );
  }, [infoCustomerByFields]);

  useEffect(() => {
    if (infoCustomer) {

      gListFieldsActive();
      gInfoCustomerByFields();
    }
  }, [infoCustomer]);

  return (
    <div className="dark-user-profile">
      {
        isSettingShow && (
          <CustomerFeilds
            isSettingShow={isSettingShow}
            type={1}
            dataFilterActive={dataFilterActive}
            dataFilterNoActive={dataFilterNoActive}
            onSaveDataFields={onSaveDataFields}
            onClose={() => setSettingShow(false)}
          />
        )
      }
      {/* benefitShow */}
      {
        isShowBenefit && <ShowDetailBenefit
          className="show"
          dataInfoCardCustomer={dataInfoCardCustomer}
          onClose={() => { setShowBenefit(false) }}
        />
      }

      {/* Settings Icon */}


      {/* Profile Header */}



      {/* Nếu không chỉnh sửa: hiển thị thông tin */}

      {/* Bảng thông tin cá nhân */}
      {!isEditing ?
        <div className="custom-page-css flex flex-col h-full  overflow-hidden ">
          <div className="custom-page-css flex items-center justify-end gap-1  top-right">
            <div className="w-6 h-6 d-flex justify-center align-center cursor-pointer border-D9D9D9 rounded-2 color-icon-setting"
              onClick={() => setIsEditing(true)}
            >
              <EditOutlined className="text-sm" />
            </div>
          </div>
          <div className="profile-header " style={{ marginBottom: 0 }}>
            <div className="avatar">
              <img
                src={URL_CUSTOMER + infoCustomer?.image}
                alt="Avatar"
                onError={(e) => {
                  e.currentTarget.src = (infoCustomer?.gender === 1 ? avatarFemale : avatarMale);
                }}
              />
            </div>
            <div className="custom-page-css w-full items-center justify-center relative">
              <div className="profile-info">
                <h2 className="name font-light font-light text-000000">


                  {(infoCustomer && infoCustomer.userName && infoCustomer?.userName.length > 0) ? capitalizeEachWord(infoCustomer?.permissions?.username ? infoCustomer?.userName[0].username : NO_VIEW) : NO_DATA}
                </h2>
                <div className="absolute top-0 right-0">
                  {
                    (infoCustomer?.userName?.length ?? 0) > 1 ?
                      <Tooltip
                        placement="right"
                        color="white"
                        title={
                          <div
                            style={{
                              maxHeight: 400,       // chiều cao cố định
                              overflowY: "auto",    // bật scroll dọc
                            }}
                            className="space-y-2"
                          >
                            {
                              infoCustomer?.userName?.map((item: any, i: any) => (
                                <div key={i} className="flex items-center gap-2">
                                  <span className="color-bage-custom fs-14">

                                    {capitalizeEachWord(item.username ?? NO_DATA)}
                                  </span>
                                  {/* <span className="color-gold-main fs-14">
                              ( {getTitleSelectOption(sLTypePhone, item.categoryPhoneId)} )
                            </span> */}
                                </div>
                              ))
                            }
                          </div>
                        }
                      >
                        <div className="action-icons action-icons-bage-2  px-2 fs-14 cursor-pointer ml-1">
                          <div className="font-light color-bage">
                            {infoCustomer?.userName?.length}
                          </div>
                          <img src={info_cicrle} alt="Avatar" />
                        </div>
                      </Tooltip> :
                      ''
                  }
                </div>
                <p className=" custom-page-css text-sm font-light text-000000 pb-1">
                  CID: {infoCustomer?.permissions?.code ? infoCustomer?.code : NO_VIEW}
                </p>

                {/* {infoCustomer?.businessCheck === CustomerType.Individual &&
                  <div className="basic-info font-light flex items-center justify-center">
                    <span>{infoCustomer?.permissions?.gender ? (dataGender[infoCustomer?.gender ?? 2].title) : NO_VIEW}</span>
                    <span className="dot-custom">•</span>


                    <span>{infoCustomer?.age ?? "--"} tuổi</span>
                    <span className="dot-custom">•</span>
                    <span>
                      {infoCustomer?.permissions?.statusMarital ? (dataStatusMarital[infoCustomer?.statusMarital ?? 2].title) : NO_VIEW}
                    </span>
                  </div>
                } */}
              </div>

            </div>
          </div>
          <div className="flex items-center mb-3 flex-wrap justify-betweeen">
            <div className="basic-info font-light flex items-center justify-center">
              {
                infoCustomer?.businessCheck === CustomerType.Individual &&
                <div className="flex items-center gap-2">
                  <img src={iconSex} alt="" className="w-4 h-4" />
                  <div className="custom-page-css text-sm font-light text-000000 ">
                    {infoCustomer?.permissions?.gender ? (dataGender[infoCustomer?.gender ?? 2].title) : NO_VIEW}
                  </div>
                  <span className="dot-custom">•</span>
                </div>
              }

              <div className="flex items-center gap-2">
                <img src={iconOld} alt="" className="w-4 h-4" />
                <div className="custom-page-css text-sm font-light text-000000 ">
                  {infoCustomer?.permissions?.age ? (infoCustomer?.age ?? "--") : NO_VIEW} tuổi
                </div>
              </div>
            </div>
          </div>
          {
            infoCustomer?.businessCheck === CustomerType.Individual &&
            <div className="flex items-center gap-2 pb-2">
              <img src={iconMarriage} alt="" />
              <div className="custom-page-css text-sm font-light text-000000 ">
                {infoCustomer?.permissions?.statusMarital ? (dataStatusMarital[infoCustomer?.statusMarital ?? 2].title) : NO_VIEW}
              </div>
            </div>
          }

          <>
            {/* SĐT */}
            <div className="flex items-center mb-3 flex-wrap justify-betweeen">
              <div className="flex items-center gap-2">
                <img src={phone_icon} alt="" />
                <div className="custom-page-css text-sm font-light text-000000 ">
                  {infoCustomer?.permissions?.phone ? (infoCustomer?.phone[0]?.phone ?? NO_DATA) : NO_VIEW}
                </div>
              </div>

              {
                infoCustomer?.phone && infoCustomer?.permissions?.phone && infoCustomer?.phone?.length > 1 ?
                  <Tooltip
                    placement="right"
                    color="white"
                    title={
                      <div
                        style={{
                          maxHeight: 400,       // chiều cao cố định
                          overflowY: "auto",    // bật scroll dọc
                        }}
                        className="space-y-2"
                      >
                        {
                          infoCustomer?.phone?.map((item, i) => (
                            <div key={i} className="flex items-center gap-2">
                              <span className="color-bage-custom fs-14">
                                {item.phone}
                              </span>
                              <span className="color-gold-main fs-14">
                                ( {getTitleSelectOption(sLTypePhone, item.categoryPhoneId)} )
                              </span>
                            </div>
                          ))
                        }
                      </div>
                    }
                  >
                    <div className="action-icons action-icons-bage ml-auto px-2 fs-14 cursor-pointer">
                      <div className="font-light color-bage">
                        {infoCustomer?.phone?.length}
                      </div>
                      <img src={info_cicrle} alt="Avatar" />
                    </div>
                  </Tooltip> :
                  ''
              }
            </div>

            {/* email */}
            <div className="flex items-center mb-3 flex-wrap justify-betweeen">
              <div className="flex items-center gap-2">
                <img src={email_icon} alt="" />
                <div className="custom-page-css text-sm font-light text-000000 ">
                  {infoCustomer?.permissions?.email ? (infoCustomer?.email[0]?.email ?? NO_DATA) : NO_VIEW}
                </div>
              </div>
              {
                infoCustomer?.email && infoCustomer?.permissions?.email && infoCustomer?.email?.length > 1 ?
                  <Tooltip
                    placement="right"
                    color="white"
                    title={
                      <div
                        style={{
                          maxHeight: 400,       // chiều cao cố định
                          overflowY: "auto",    // bật scroll dọc
                        }}
                        className="space-y-2"
                      >
                        {infoCustomer?.email.map((item, i) => (
                          <div key={i} className="flex items-center gap-2">
                            <span className="color-bage-custom fs-14">{item.email}</span>
                          </div>
                        ))}
                      </div>
                    }
                  >
                    <div className="action-icons action-icons-bage ml-auto px-2 fs-14 cursor-pointer">
                      <div className="font-light color-bage">
                        {infoCustomer?.email?.length}
                      </div>
                      <img src={info_cicrle} alt="Avatar" />
                    </div>
                  </Tooltip> :
                  ''
              }
            </div>
            {infoCustomer?.permissions?.customerType &&
              <div className="flex gap-2">
                {
                  infoCustomer?.customerType.map((tag, i) => (
                    <span
                      key={i}
                      style={{
                        backgroundColor: "#" + tag.backgroundColor,
                        color: "#" + tag.color,
                        padding: "4px 8px",
                        borderRadius: "100px",
                        fontSize: "12px",
                        fontWeight: 500,
                      }}
                    >
                      {tag.code}
                    </span>
                  ))
                }
              </div>
            }
          </>

          <div className="custom-page-css w-full flex items-center justify-between gap-2 mb-3 pt-3">
            <div className="custom-page-css flex items-center gap-2">
              {infoCustomer?.permissions?.rank ?
                <>
                  <div className="img-box custom-page-css flex items-center">

                    <img
                      src={URL_RANK + infoCustomer?.rank?.icon}
                      style={{
                        width: 20,
                        height: 20,
                        objectFit: 'cover'
                      }}
                      onError={(e) => { e.currentTarget.src = none_rank; }}
                      alt="" />
                  </div>
                  <span className="custom-page-css text-sm font-light text-000000">{infoCustomer?.rank?.title ?? 'Chưa phát hành hạng thành viên'}</span>
                </>
                :
                NO_VIEW
              }




            </div>
            {infoCustomer?.permissions?.rank &&
              <span
                className={infoCustomer?.rank ? "custom-page-css text-sm font-light text-096DD9 cursor-pointer" : 'd-none'}
                onClick={() => { setShowBenefit(true); gInfoCardCustomer(infoCustomer?.id) }}
              >Quyền lợi</span>
            }
          </div>







          <div
            className={`information-tab__content-left mt-2 ${!infoCustomerByFields.length ? "d-none" : ""}`}
          >
            <div className="d-flex justify-between w-full mb-1 items-center">
              <span className="custom-page-css text-sm font-medium text-000000">{infoCustomer?.businessCheck === CustomerType.Individual ? 'Thông tin cá nhân' : 'Thông tin doanh nghiệp'}</span>
              <div
                className="w-6 h-6 d-flex justify-center align-center cursor-pointer border-D9D9D9 rounded-2 color-icon-setting"
                onClick={() => setSettingShow(true)}
              >
                <SettingOutlined className="text-sm" />
              </div>
            </div>
            <div className="">
              <div className="custom-page-css flex flex-col gap-2">
                {
                  fieldsToShow.map((item, i) => (
                    <ItemsInfomation
                      key={i}
                      isIndividual={infoCustomer?.businessCheck === CustomerType.Individual}
                      isTooltip={
                        item.fieldCode === "cus_group_name" || item.fieldCode === "cus_dms_id_card_no" ||
                        item.fieldCode === "cus_address" || item.fieldCode === "cus_lifecycle_status" ||
                        item.fieldCode === "cus_city" || item.fieldCode === "cus_ward" || item.fieldCode === "cus_branch_name"
                      }
                      fieldCustomer={item}
                    />
                  ))
                }

                {
                  infoCustomerByFieldsActive.length > 11 && (
                    <div className="text-center mt-2">
                      <div
                        className="d-flex justify-center w-full cursor-pointer gap-1"
                        onClick={toggleShowAll}
                      >
                        <p className="text-sm font-regular text-1890FF">
                          {advanced ? "Thu gọn" : "Nâng cao"}
                        </p>
                        {advanced ? (
                          <UpOutlined className="text-10-px text-1890FF" />
                        ) : (
                          <DownOutlined className="text-10-px text-1890FF" />
                        )}
                      </div>
                    </div>
                  )
                }
              </div >
            </div >
          </div >
        </div>
        :

        <EditInfomation
          isEdit={isEditing}
          sLTypePhone={sLTypePhone}
          infoCustomer={infoCustomer}
          infoCustomerByFields={infoCustomerByFields}
          resultFormSubmit={resultFormSubmitPersonalInforLeft}
          setIsEditing={setIsEditing}
        />
      }


    </div >
  );
};

export default InfomationLeft;
